import { DisabledPrompt, Link, useModel } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import CustomContentHeaderWidget from "components/shared/views/CustomContentHeaderWidget";
import { PrimaryButton, SecondaryButton, UITextInput } from "components/ui";
import "./styles.css";
import "./mobile.css";


/**
 * @function SecurityQuestionsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SecurityQuestionsPage
 */
export default function SecurityQuestionsPage(props) {
  const { branding } = useModel();
  const { options } = branding;
  const subheaderText = options.securityquestions_subheader_abi22;

  return (
    <PageContainer className="security-questions-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Security Questions" />
          { subheaderText && <CustomContentHeaderWidget content = { subheaderText }/>}
          <FormContainer className="security-questions-form">
            <FormRowView>
              <SecurityQuestionsSelect value="instrument" />
            </FormRowView>
            <FormRowView>
              <UITextInput />
            </FormRowView>
            <FormRowView>
              <SecurityQuestionsSelect value="sibling-location" />
            </FormRowView>
            <FormRowView>
              <UITextInput />
            </FormRowView>
            <FormRowView>
              <SecurityQuestionsSelect value="celebrity" />
            </FormRowView>
            <FormRowView>
              <UITextInput />
            </FormRowView>
            <FormButtonRow>
              <DisabledPrompt>
                <PrimaryButton text="Continue" />
              </DisabledPrompt>
              <Link className="cancel-button" to="/profile">
                <SecondaryButton text="Cancel" />
              </Link> 
            </FormButtonRow>
          </FormContainer> 
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}

/**
 * @function SecurityQuestionsSelect
 * @return {React.Component}
 * @exported false
 * @description A custom select shown in the page.
 */
function SecurityQuestionsSelect(props) {
  const value = props.value ?? "instrument";

  return (
    <CustomSelect value={ value }>
      <CustomSelectItem value="instrument">What is the first musical instrument you learned to play?</CustomSelectItem>
      <CustomSelectItem value="sibling-location">Where does your nearest sibling live?</CustomSelectItem>
      <CustomSelectItem value="celebrity">Who is your favorite celebrity?</CustomSelectItem>
      <CustomSelectItem value="candy">What is your favorite candy?</CustomSelectItem>
      <CustomSelectItem value="animal">What is your favorite animal?</CustomSelectItem>
      <CustomSelectItem value="book-author">What is the last name of the author of the best book you ever read?</CustomSelectItem>
      <CustomSelectItem value="music-group">Who is your favorite musical performer/group?</CustomSelectItem>
      <CustomSelectItem value="game">What is your favorite game?</CustomSelectItem>
      <CustomSelectItem value="song">What is your favorite song?</CustomSelectItem>
      <CustomSelectItem value="movie">What is your favorite movie?</CustomSelectItem>
      <CustomSelectItem value="grandparent-nickname">What is the nickname you gave your favorite grandparent?</CustomSelectItem>
      <CustomSelectItem value="musician">Who is your favorite musician?</CustomSelectItem>
      <CustomSelectItem value="author">Who is your favorite author?</CustomSelectItem>
      <CustomSelectItem value="painter">Who is your favorite painter?</CustomSelectItem>
      <CustomSelectItem value="childhood-place">What was your favorite place to visit as a child?</CustomSelectItem>
      <CustomSelectItem value="shampoo">What brand shampoo do you use?</CustomSelectItem>
      <CustomSelectItem value="sports-team-rival">What sports team do you love to see lose?</CustomSelectItem>
      <CustomSelectItem value="childhood-hero">Who was your childhood hero?</CustomSelectItem>
      <CustomSelectItem value="retirement-place">Where do you want to retire?</CustomSelectItem>
      <CustomSelectItem value="dream-car">What is your dream car?</CustomSelectItem>
      <CustomSelectItem value="dream-job">What is your dream job?</CustomSelectItem>
      <CustomSelectItem value="childhood-dream-job">What was your dream job as a child?</CustomSelectItem>
      <CustomSelectItem value="pet-peeve">What is your biggest pet peeve?</CustomSelectItem>
      <CustomSelectItem value="rehearsal-dinner">Where was your wedding rehearsal dinner held?</CustomSelectItem>
      <CustomSelectItem value="favorite-quote">What is your favorite quote?</CustomSelectItem>
    </CustomSelect>
  );
}